var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asset-container"},[_c('div',{staticClass:"asset-level1"},[_c('Level1Content',{attrs:{"items":_vm.totals}})],1),_c('div',{staticClass:"asset-level2"},[_c('deviceList',{attrs:{"devices":_vm.devices}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }